module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix",
    attrs: {
      "id": "stockQuery"
    }
  }, [_c('el-col', [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "inline": true,
      "model": _vm.form,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择仓库类型"
    },
    on: {
      "change": _vm.handlerWarehouseTypeChange
    },
    model: {
      value: (_vm.form.warehouseType),
      callback: function($$v) {
        _vm.$set(_vm.form, "warehouseType", $$v)
      },
      expression: "form.warehouseType"
    }
  }, _vm._l((_vm.wareArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "残值类型",
      "clearable": ""
    },
    model: {
      value: (_vm.form.residualType),
      callback: function($$v) {
        _vm.$set(_vm.form, "residualType", $$v)
      },
      expression: "form.residualType"
    }
  }, _vm._l((_vm.residualList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "品牌"
    },
    on: {
      "change": _vm.choseBrand
    },
    model: {
      value: (_vm.form.brandId),
      callback: function($$v) {
        _vm.$set(_vm.form, "brandId", $$v)
      },
      expression: "form.brandId"
    }
  }, _vm._l((_vm.brandList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "品类"
    },
    on: {
      "change": _vm.choseCategory
    },
    model: {
      value: (_vm.form.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.form, "categoryId", $$v)
      },
      expression: "form.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('el-option', {
      key: index + item,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "型号"
    },
    on: {
      "change": _vm.choseModel
    },
    model: {
      value: (_vm.form.modelId),
      callback: function($$v) {
        _vm.$set(_vm.form, "modelId", $$v)
      },
      expression: "form.modelId"
    }
  }, _vm._l((_vm.modelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "物料"
    },
    model: {
      value: (_vm.form.materialCoding),
      callback: function($$v) {
        _vm.$set(_vm.form, "materialCoding", $$v)
      },
      expression: "form.materialCoding"
    }
  }, _vm._l((_vm.materialFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialName,
        "value": item.materialCoding
      }
    }, [_vm._v(_vm._s(item.materialName) + "\n              ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "物料编码"
    },
    model: {
      value: (_vm.searchForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "物料名称"
    },
    model: {
      value: (_vm.searchForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "序列号"
    },
    model: {
      value: (_vm.searchForm.code),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitSearch('searchForm')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearFrom()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.exportWarehouseList()
      }
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": "",
      "id": "tableId"
    }
  }, [_c('el-table-column', {
    attrs: {
      "column-key": "index",
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "materialNumber",
      "align": "center",
      "prop": "materialNumber",
      "width": "150",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "modelName",
      "align": "center",
      "prop": "modelName",
      "width": "110",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "materialName",
      "align": "center",
      "width": "230",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "warehouseName",
      "align": "center",
      "width": "120",
      "prop": "warehouseName",
      "label": "所在仓库"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "warehouseType",
      "align": "center",
      "prop": "warehouseType",
      "label": "仓库类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("sysCodeFileter")(scope.row.warehouseType, 'warehouse_type')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), (_vm.form.warehouseType == 'FBC') ? _c('el-table-column', {
    attrs: {
      "column-key": "residualType",
      "align": "center",
      "prop": "residualType",
      "label": "残值类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("sysCodeFileter")(scope.row.residualType, 'residual_type')) + "\n          ")]
      }
    }], null, false, 2173133510)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "inventoryTotal",
      "align": "center",
      "prop": "inventoryTotal",
      "label": "库存总数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.inventoryTotal) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "broughtTotal",
      "align": "center",
      "prop": "broughtTotal",
      "label": "已领数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "freezeTotal",
      "align": "center",
      "prop": "freezeTotal",
      "label": "冻结数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "column-key": "availableTotal",
      "align": "center",
      "prop": "availableTotal",
      "label": "可用数量"
    }
  }), _vm._v(" "), (_vm.form.warehouseType == 'LPC' || _vm.form.warehouseType == 'SHC' || _vm.form.warehouseType == 'SQC') ? _c('el-table-column', {
    attrs: {
      "column-key": "inventoryTotalPrice",
      "align": "center",
      "prop": "inventoryTotalPrice",
      "label": "库存总价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.warehouseType == 'LPC' || _vm.form.warehouseType == 'SHC' || _vm.form.warehouseType == 'SQC') ? _c('el-table-column', {
    attrs: {
      "column-key": "broughtTotalPrice",
      "align": "center",
      "prop": "broughtTotalPrice",
      "label": "已领总价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.warehouseType == 'LPC' || _vm.form.warehouseType == 'SHC' || _vm.form.warehouseType == 'SQC') ? _c('el-table-column', {
    attrs: {
      "column-key": "freezeTotalPrice",
      "align": "center",
      "prop": "freezeTotalPrice",
      "label": "冻结总价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.warehouseType == 'LPC' || _vm.form.warehouseType == 'SHC' || _vm.form.warehouseType == 'SQC') ? _c('el-table-column', {
    attrs: {
      "column-key": "availableTotalPrice",
      "align": "center",
      "prop": "availableTotalPrice",
      "label": "可用总价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.warehouseType == 'FBC') ? _c('el-table-column', {
    attrs: {
      "column-key": "inventoryResidualPrice",
      "align": "center",
      "prop": "inventoryResidualPrice",
      "label": "库存残价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.warehouseType == 'FBC') ? _c('el-table-column', {
    attrs: {
      "column-key": "broughtResidualPrice",
      "align": "center",
      "prop": "broughtResidualPrice",
      "label": "已领残价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.warehouseType == 'FBC') ? _c('el-table-column', {
    attrs: {
      "column-key": "freezeResidualPrice",
      "align": "center",
      "prop": "freezeResidualPrice",
      "label": "冻结残价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.warehouseType == 'FBC') ? _c('el-table-column', {
    attrs: {
      "column-key": "availableResidualPrice",
      "align": "center",
      "prop": "availableResidualPrice",
      "label": "可用残价"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.all_serial_number) ? _c('el-table-column', {
    attrs: {
      "column-key": "all_serial_number",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.searchSn(scope.row)
            }
          }
        }, [_vm._v("查看\n            ")])]
      }
    }], null, false, 3256048978)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100, 1000],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-content-self",
    attrs: {
      "title": "序列号类型",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "table-filter-content"
  }, [_c('el-button', {
    class: {
      active: _vm.shift == 0
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(0)
      }
    }
  }, [_vm._v("全部序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 1
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(1)
      }
    }
  }, [_vm._v("可用序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 2
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(2)
      }
    }
  }, [_vm._v("已领序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 3
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(3)
      }
    }
  }, [_vm._v("冻结序列号")])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "dialog-code-content",
    attrs: {
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    }
  }, _vm._l((_vm.codeList), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('p', [_vm._v(_vm._s(item))])])
  }), 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.numberPages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.numberPages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.numberPages.total
    },
    on: {
      "size-change": _vm.handleNumberSizeChange,
      "current-change": _vm.handleNumberCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-05dd3a4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storehouseManage/stockQuery.vue
// module id = 1571
// module chunks = 0